import { render } from "./Check_Busines.vue?vue&type=template&id=a3fa656e"
import script from "./Check_Busines.vue?vue&type=script&lang=js"
export * from "./Check_Busines.vue?vue&type=script&lang=js"
script.render = render

export default script